<template>
  <div class="mod-joylearning__offringlist}">
    <div class="pkg-search-box">
      <el-form
          class="pkg-content"
          label-width="auto"
          label-position="top"
          :model="dataForm"
          ref="dataForm"
          @keyup.enter.native="getDataList()"
      >
        <el-row class="margb10">
          <el-col :span="5">
            <el-form-item label="规则编号">
              <el-input
                  v-model="dataForm.ruleNo"
                  placeholder="规则编号"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="规则名称">
              <el-input
                  v-model="dataForm.ruleName"
                  placeholder="规则名称"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="用户ID">
              <el-input
                  v-model="dataForm.userCode"
                  :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="员工号">
              <el-input
                  v-model="dataForm.userCardNo"
                  :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button
                  class="M-search"
                  style="margin-bottom: 7px"
                  type="primary"
                  @click="getDataListMerge"
              >{{ $t("course.query") }}
              </el-button>
              <el-button
                  class="el-back M-search M-margin-l"
                  type="info"
                  @click="again"
              >{{ $t("reset") }}
              </el-button>
            </el-col>
          </el-col>
          <el-col :span="5">
            <el-form-item label="用户姓名">
              <el-input
                  v-model="dataForm.userName"
                  :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="faO"
          >
            <el-form-item label="所属公司名称" class="f1">
              <el-input
                  v-model="dataForm.registeOrgNameAll"
                  :placeholder="$t('简称/全称/NSC/BBA')"
              ></el-input>
            </el-form-item
            >
          </el-col>
          <el-col :span="5">
            <el-form-item label="课程代码">
              <el-input
                  v-model="dataForm.courseCode"
                  :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="课程名称">
              <el-input
                  v-model="dataForm.courseName"
                  :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <!-- ---->
        <el-row class="margb10" v-if="isOpen">

          <el-col :span="10">
            <el-form-item style="width: 90% !important" label="课程完成时间">
              <el-date-picker
                  @change="updateTimeChange"
                  v-model="tansactionTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5"
          >
            <el-form-item label="排期编号">
              <el-input
                  v-model="dataForm.offeringNo"
                  :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item
            >
          </el-col>
          <el-col :span="5">
            <el-form-item label="记录类型" prop="courseCode">
              <el-select v-model="dataForm.type" clearable placeholder="请选择">
                <el-option
                    v-for="(item,index) in state1"
                    :key="item.index"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item
            >
          </el-col>
          <el-col :span="4">
            <el-col :span="24"></el-col>
          </el-col>
        </el-row>
        <el-row class="margb10" v-if="isOpen">

          <el-col :span="5">
            <el-form-item label="减免区分" prop="courseCode">
              <el-select
                  v-model="dataForm.isFreeRegiste"
                  clearable
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in state2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item
            >
          </el-col>
<!--          <el-col :span="5">-->
<!--            <el-form-item label="关课时是否减免" prop="courseCode">-->
<!--              <el-select-->
<!--                  v-model="dataForm.isFreeEnd"-->
<!--                  clearable-->
<!--                  placeholder="请选择"-->
<!--              >-->
<!--                <el-option-->
<!--                    v-for="item in state3"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item-->
<!--            >-->
<!--          </el-col>-->
          <el-col :span="5" class="f2">
            <div class="box"></div>
            <el-form-item>
              <el-checkbox
                  name="type"
                  v-model="dataForm.isShowDiff"
              >
                只显示减免差异数据
                <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top"
                >
                  <img
                          style="width: 14px; height: 14px"
                          src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                          alt=""
                  />
                  <div slot="content">勾选后，只显示报名时点和关课时点，减免发生变化<br/>的数据，如：报名时为减免，关课时变为了收费。<br/>如需要查看所有数据，去掉勾选后，点击查询即可。</div>
                </el-tooltip>
              </el-checkbox>

            </el-form-item>

          </el-col>
        </el-row>
        <ToggleDiv @toggle="openAction"></ToggleDiv>

      </el-form>
      <el-row style="text-align: center; margin-bottom: 10px">
        <!-- <el-col :span="24">
          <div class="show-or-hide-icon"></div>
        </el-col> -->
      </el-row>
    </div>
    <div class="pkg-content">
      <!-- 表头动态展示 -->
      <el-row>
        <div class="dc">
          <el-button type="primary" @click="exportHandle">导出</el-button>
        </div>
      </el-row>
      <el-table
          v-loading="dataListLoading"
          ref="multipleTable"
          :data="dataList"
          border
          :row-style="{ height: 48 + 'px' }"
          :cell-style="{ textAlign: 'center' }"
      >
        <!--  培训记录编号  -->
        <el-table-column
            prop="trainingKey"
            label="培训记录编号"
            header-align="center"
            align="center"
            min-width="290"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 记录类型-->
        <el-table-column
                prop=""
                label="记录类型"
                header-align="center"
                min-width="120"
                :show-overflow-tooltip="true"
                :formatter="
            (row, column) => {
              return row.type === 'close' ? '关课' : '报名';
            }
          "
                align="center"
        >
          <template slot="header" slot-scope="scope">
            <div style="line-height: 1.15;display: block;">
              记录类型
              <el-tooltip
                      class="item"
                      effect="dark"
                      content="会在报名和关课时记录信息数据。"
                      placement="top"
              >
                <img
                        style="width: 14px; height: 14px"
                        src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                        alt=""
                />
              </el-tooltip>
            </div>
          </template>

        </el-table-column>
        <!-- 减免区分 -->
        <el-table-column
            prop=""
            label="减免区分"
            header-align="center"
            min-width="120"
            :show-overflow-tooltip="true"
            :formatter="
            (row, column) => {
              return row.isFree === '1' ? '减免' : '不减免';
            }
          "
            align="center"
        >
          <template slot="header" slot-scope="scope">
            <div style="line-height: 1.15;display: block;">
              减免区分
              <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top"
              >
                <div slot="content">
                  减免：记录时点培训记录符合任意减免规则<br/>
                  不减免：记录时点培训记录不符合任何减免规则<br/>
                </div>
                <img
                        style="width: 14px; height: 14px"
                        src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                        alt=""
                />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <!--用户ID-->
        <el-table-column
            prop="userCode"
            label="用户ID"
            header-align="center"
            align="left"
            :show-overflow-tooltip="true"
            min-width="110"
        ></el-table-column>
        <!--员工号-->
        <el-table-column
            prop="userCardNo"
            label="员工号"
            header-align="center"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
        ></el-table-column>
        <!--用户姓名-->
        <el-table-column
            prop="userName"
            label="用户姓名"
            header-align="center"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
        ></el-table-column>
        <!-- 所属公司名称 -->
        <el-table-column
            prop="registeOrgNameAll"
            label="所属公司名称"
            header-align="center"
            align="center"
            min-width="250"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 课程代码 -->
        <el-table-column
            prop="courseCode"
            label="课程代码"
            header-align="center"
            min-width="110"
            align="center"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <!-- 课程名称 -->
        <el-table-column
            prop="courseName"
            label="课程名称"
            header-align="center"
            align="center"
            min-width="100"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 排期编号 -->
        <el-table-column
            prop="offeringNo"
            label="排期编号"
            header-align="center"
            min-width="150"
            :show-overflow-tooltip="true"
            align="center"
        >
        </el-table-column>
        <!-- 排期开始时间 -->
        <el-table-column
            prop="trainingStartDate"
            label="排期开始时间"
            header-align="center"
            min-width="150"
            :show-overflow-tooltip="true"
            align="center"
        >
        </el-table-column>
        <!-- 排期结束时间 -->
        <el-table-column
            prop="trainingEndDate"
            label="排期结束时间"
            header-align="center"
            min-width="150"
            :show-overflow-tooltip="true"
            align="center"
        >
        </el-table-column>
        <!-- 培训记录状态 -->
        <el-table-column
            prop="trainingStatus"
            label="培训记录状态"
            header-align="center"
            min-width="150"
            :show-overflow-tooltip="true"
            align="center"
        >
          <template slot="header" slot-scope="scope">
            <div style="line-height: 1.15;display: block;">
              培训记录状态
              <el-tooltip
                      class="item"
                      effect="dark"
                      content="记录时点该培训记录状态。"
                      placement="top"
              >
                <img
                        style="width: 14px; height: 14px"
                        src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                        alt=""
                />
              </el-tooltip>
            </div>
          </template>
          <template #default="scoped">
            <!-- 插值表达式支持函数调用,值为函数的返回值 -->
            {{ statusFormatter(scoped.row) }}
          </template>
        </el-table-column>
        <!-- 规则编号 -->
        <el-table-column
            prop="ruleNo"
            label="规则编号"
            header-align="center"
            min-width="110"
            :show-overflow-tooltip="true"
            align="center"
        >
        </el-table-column>
        <!-- 规则名称 -->
        <el-table-column
            prop="ruleName"
            label="规则名称"
            header-align="center"
            min-width="110"
            :show-overflow-tooltip="true"
            align="center"
        >
        </el-table-column>
        <!-- 规则版本号 -->
        <el-table-column
            prop="versionNo"
            label="规则版本号"
            header-align="center"
            min-width="110"
            :show-overflow-tooltip="true"
            align="center"
        >
        </el-table-column>
        <!-- 记录时间 -->
        <el-table-column
            prop="createTime"
            label="记录时间"
            header-align="center"
            min-width="110"
            :show-overflow-tooltip="true"
            align="center"
        >
        </el-table-column>
        <!--操作 -->
        <el-table-column
            :label="$t('offering.operation')"
            fixed="right"
            header-align="center"
            align="center"
            min-width="80"
        >
          <template slot-scope="scope">
            <div class="">
              <el-link
                  type="primary"
                  :underline="false"
                  @click="handleView(scope.row)"
              >查看
              </el-link
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>

    <el-dialog :modal="false" width="30%" :visible.sync="dialogVisible">
      <el-form label-width="auto" label-position="left" :model="dialogForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="规则版本">
              <el-select v-model="dialogForm.versions" placeholder="请选择">
                <el-option
                    v-for="item in versions"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="margin-top: 20px">
        <el-col :span="24" align="right">
          <el-button
              :disabled="!dialogForm.versions && dialogForm.versions.length <= 0"
              type="primary"
              @click="handleConfirm"
          >
            确定
          </el-button>

          <el-button type="primary" @click="dialogVisible = false">
            取消
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import ToggleDiv from '@/components/toggle-div'
import Vue from 'vue'

export default {
  mixins: [mixinViewModule],
  components: {
    ToggleDiv
  },
  data() {
    let _this = this;
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/learning/rule/freerulesnapshot/page",
        getDataListIsPage: true,
        exportURL: "/learning/rule/freerulesnapshot/export",
      },
      isOpen: false,
      ruleVersions: [],
      tansactionTime: [], // 交易时间
      saveOrderDisable: false,
      dataForm: {
        // page:1,//页码
        // limit:10,//条数
        ruleNo: '', //规则编号
        ruleName: "", //规则名称
        userCode: '', //用户id
        userName: '', // 用户姓名
        courseCode: '', //课程代码
        courseName: '', //课程名称
        trainingEndDateS: '', //排期结束时间起
        trainingEndDateE: '', //排期结束时间止
        offeringNo: '', //排期编号
        type: '', //记录类型
        isFreeRegiste: '', //报名时是否减免
        isFreeEnd: '', //关课时是否减免
        isShowDiff: true, //只显示减免差异数据
        trainingStatus: "",//培训记录状态
        versionNo: '', //规则版本号
        userCardNo: '',//员工号
        registeAbbreviation: '',//所属公司名称
        feeId: '', //费用ID
        snapshotId: '',//角色快照ID,
        registeOrgNameAll: '',//公司名称合并
      },
      dialogForm: {
        versions: "",
      },
      state1: [
        {
          value: "regist",
          label: "报名",
        },
        {
          value: "close",
          label: "关课",
        },
      ],
      state2: [
        {
          value: "1",
          label: "减免",
        },
        {
          value: "0",
          label: "不减免",
        },
      ],
      state3: [
        {
          value: "1",
          label: "减免",
        },
        {
          value: "0",
          label: "不减免",
        },
      ],
      versions: [],
      dialogVisible: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    // saveOrderDisable() {
    // for (let index = 0; index < this.dataList.length; index++) {
    //   const element = this.dataList[index];
    //   if (element.priorityLevel && element.oldPriorityLevel && element.oldPriorityLevel != element.priorityLevel) {
    //     return false;
    //   }
    // }
    // return true;
    // }
  },
  methods: {
    // 状态转换
    statusFormatter(row) {
      return Vue.filter('coverEnum')(row.trainingStatus, 'training_status')
    },
    // 搜索条件展开事件
    openAction(val) {
      this.isOpen = val
    },
    // 页面初始化
    init() {
      console.log('init')
    },
    updateTimeChange() {
      if (this.tansactionTime && this.tansactionTime.length > 1) {
        this.dataForm.trainingEndDateS = this.tansactionTime[0];
        this.dataForm.trainingEndDateE = this.tansactionTime[1];
      } else {
        this.dataForm.trainingEndDateS = '';
        this.dataForm.trainingEndDateE = '';
      }
    },

    // 查询
    getDataListMerge() {
      this.page = 1;
      this.getDataList();
    },

    // 重置
    again() {
      this.tansactionTime = [];
      this.dataForm = {
        // page:1,//页码
        // limit:10,//条数
        ruleNo: '', //规则编号
        ruleName: "", //规则名称
        userCode: '', //用户id
        userName: '', // 用户姓名
        courseCode: '', //课程代码
        courseName: '', //课程名称
        tansactionTime: '',
        trainingEndDateS: '', //排期结束时间起
        trainingEndDateE: '', //排期结束时间止
        offeringNo: '', //排期编号
        type: '', //记录类型
        userCardNo: '',//员工号
        isFreeRegiste: '', //报名时是否减免
        isFreeEnd: '', //关课时是否减免
        registeAbbreviation: '', //名称
        registeOrgNameAll: '',
        isShowDiff: true //只显示减免差异数据
      };
      this.dataForm.ruleName = "";
      this.dataForm.ruleCreateUser = "";
      this.dataForm.ruleUpdateUser = "";
      this.dataForm.status = "";
      this.page = 1;
      this.getDataList();
    },

    // // 查看
    handleView(row) {
      console.log(row);
      // row.isFree === '1' ? '减免' : '不减免'

      if (row.isFree === '1') {
        //减免跳转路由
        this.$router.push({
          name: "rainingreduceInfoDetailView",
          query: {
            feeId: row.feeId,
            snapshotId: row.snapshotId,
            type: row.type
          },
        });
        this.$eventHub.$emit("rainingreduceInfoView", "activated");
      } else {
        this.$router.push({
          name: "rainingreduceInfoDetailViewTwo",
          query: {
            feeId: row.feeId,
            snapshotId: row.snapshotId,
            type: row.type,
            createTime: row.createTime,
            offeringTime: row.trainingEndDate
          },
        });
        this.$eventHub.$emit("rainingreduceInfoView", "activated");
      }

    },
    // 更新状态
    updateStatus(row) {
      row = JSON.parse(JSON.stringify(row));
      if (row.status === "1") {
        this.$confirm("确定要设置为不活动？ ", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(() => {
              row.status = "0";
              this.updateStatusRequest(row);
            })
            .catch((err) => {
              console.log(err)
            });
      } else {
        row.status = "1";
        this.updateStatusRequest(row);
      }
    },
    priorityLevelBlur(row) {
      let level = parseInt(row.priorityLevel, 10);
      if (!row.priorityLevel || level <= 0 || !level) {
        row.priorityLevel = row.oldPriorityLevel;
        this.$nextTick(() => {
          this.$message({
            message: "减免顺序只能输入正整数",
            duration: 1000,
          });
        });
        setTimeout(() => {
          this.saveOrderDisable = false;
        }, 300);
      } else {
        this.saveOrderDisable = false;
      }
    },
    // 级别是否冲突
    priorityLevelIsExist() {
      let temp = [];
      for (let i = 0; i < this.dataList.length; ++i) {
        let item = this.dataList[i];
        if (
            item.status == "1" &&
            item.priorityLevel &&
            item.priorityLevel > 0
        ) {
          for (let index = i + 1; index < this.dataList.length; index++) {
            const element = this.dataList[index];
            if (element.priorityLevel === item.priorityLevel) {
              return false;
            }
          }
        }
        temp.push({
          id: item.id,
          priorityLevel: item.priorityLevel,
        });
      }
      return temp;
    },
    // 更新状态请求
    updateStatusRequest(row) {
      this.dataListLoading = true;
      this.$request
          .post("/learning/rule/freerules/changeStatus", row)
          .then((data) => {
            this.$message({
              message: this.$t("prompt.success"),
              type: "success",
              duration: 2000,
              onClose: () => {
                console.log('onClose')
              },
            });
            this.dataListLoading = false;
            this.getDataList();
          })
          .catch(() => {
            this.dataListLoading = false;
          });
    },

    // 保存减免顺序请求
    saveOrderRequest(params) {
      this.dataListLoading = true;
      this.$request
          .post(`/learning/rule/freerules/batchUpdatePriorityLevel`, params)
          .then((res) => {
            this.$message({
              message: this.$t("prompt.success"),
              type: "success",
              duration: 2000,
              onClose: () => {
                console.log('onClose')
              },
            });
            this.dataListLoading = false;
            this.getDataList();
          })
          .catch(() => {
            this.dataListLoading = false;
          });
    },
    // 查询版本下拉选
    // queryVersions(val) {
    //   //获取公司下拉框数据
    //   if (val !== '' && val !== undefined) {
    //     this.$request.get(`/learning/rule/freerules/getAllVersionList`, { id: val }).then((res) => {
    //       this.ruleVersions = res.freeRulesHisDTOList
    //       let arr = res.freeRulesHisDTOList
    //         .filter((item, index) => index < 4)
    //         .map((item, i) => {
    //           return {
    //             label: item.versionNo + '-' + item.ruleUpdateUser,
    //             value: item.id
    //           }
    //         })
    //       this.dialogForm.versions = res.id
    //       this.versions = [
    //         {
    //           label: '当前版本-' + res.ruleUpdateUser,
    //           value: res.id
    //         },
    //         ...arr
    //       ]
    //     })
    //   }
    // },
    handleConfirm(row) {
      let isNow = this.versions.some((item) => {
        if (
            item.value === this.dialogForm.versions &&
            item.label.indexOf("当前版本") > -1
        ) {
          return true;
        }
      });
      let downloadId;
      this.ruleVersions.forEach((item) => {
        if (item.id === this.dialogForm.versions) {
          downloadId = item.orgCategoryId;
        }
      });
      this.$router.push({
        name: "eightDimensionsView",
        params: {
          type: "view",
          id: this.dialogForm.versions,
          downloadId,
          isNow,
        },
      });
      this.dialogVisible = false;
      this.$eventHub.$emit("eightDimensionsView", "activated");
    },
    // 网格级别输入失去焦点
    priorityLevelInputBlur(row) {
      if (!this.priorityLevelIsExist()) {
        row.priorityLevel = row.oldLevel;
        this.$message("此顺序号已存在，请重新填写。");
      } else {
      }
    },

    // 跳转编辑页面
    sendAbilityEdit(row) {
      this.$router.push({
        name: "eightDimensionsEdit",
        params: {
          type: "edit",
          id: row.id,
          isNow: true,
        },
      });
      this.$eventHub.$emit("eightDimensionsEdit", "activated");
    },

    handleExport() {
      console.log('handleExport')
    },

    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1;
      this.limit = val;
      this.getDataList();
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val;
      this.getDataList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";

.aui-wrapper .el-date-editor .el-range-separator {
  width: 30px;
}

.jieshu .el-form-item__content {
  width: 94.5%;
}

.kaishi .el-form-item__content {
  width: 111%;
}

.el-row {
  margin-bottom: 0px;
}

#container {
  display: -webkit-flex;
}

.el-date-editor.el-input {
  width: 150px;
}

.search-item {
  width: 94% !important;
  min-width: 290px;
}

.wrapper-div {
  .el-dialog__title {
    text-align: center;
    display: block;
  }
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

 .search-item .el-form-item__content {
  margin-left: 96px !important;
}

.margb10 {
  min-height: 75px;
}

.box {
  width: 200px;
  height: 25px;
}

.dc {
  position: relative;
  margin-bottom: 10px;
}

.dcbtn {
  position: absolute;
  top: -7px;
  left: 65px;
}
</style>
